import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

function BotDetail (){
  const {user} = useUser()
  let view = contentLayout[modules.BotDetail]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.BotDetail.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.BotList}></Index>
 )
}

export default BotDetail
